import { render } from "./ButtonBase.vue?vue&type=template&id=4e72c0d0"
import script from "./ButtonBase.vue?vue&type=script&lang=js"
export * from "./ButtonBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__